import React from 'react';
import {Badge, Button, Layout, Row, Space, Typography} from "antd";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function StickyNavigationHeader({headerTitle, onBackClick, actions}) {
    const {t} = useTranslation();
    return (
        <Layout.Header
            style={{
                position: "sticky",
                top: 0,
                zIndex: 20,
                background: "rgba(255,255,255,0.85)",
                backdropFilter: "blur(6px)",
                borderBottom: "1px solid #f0f0f0",
                paddingInline: 16,
            }}
        >
            <Row align="middle" justify="space-between" style={{ maxWidth: 1200, margin: "0 auto", width: "100%" }}>
                <Space align="center" size={12}>
                    <Button type="text" onClick={() => onBackClick() }>
                        {t("common.back")}
                    </Button>
                    <Badge color="#7c3aed" />
                    <Typography.Title level={4} style={{ margin: 0 }}>
                        {headerTitle}
                    </Typography.Title>
                </Space>

                <Space>
                    {actions}
                </Space>
            </Row>
        </Layout.Header>
    )
}